import {
  LinkSideNavButton,
  RightDrawerButton,
  SideNavButton,
  SideNavButtonAlignment,
} from '@mydocma/app-container';
import { PRRoutesEnum } from '../routes/pr-route.enums';

export enum SideNavBarButtonsEnum {
  DASHBOARD = 'dashboard',
  BACK_TO_PROJECT = 'back_to_project',
  BACK_TO_PROJECT_OVERVIEW = 'back_to_project_overview',
  PROJECT_PARTICIPANTS = 'project_participants',
  TASKS = 'tasks',
  INBOX = 'inbox',
  DOCUMENTS = 'documents',
  BIM_MODELS = 'bim_models',
  PLANS = 'plans',
  PICTURES = 'pictures',
  PROJECT_CONFIGURATION = 'project_configuration',
  PROJECT_DOCUMENT_TYPE_CONFIGURATION = 'project_document_type_config',
  GLOBAL_CONFIGURATION = 'global_configuration',
  GLOBAL_DOCUMENT_TYPE_CONFIGURATION = 'global_document_type_config',
  MESSAGES = 'messages',
}

export const idToButtonMap = new Map<string, SideNavButton>([
  [
    SideNavBarButtonsEnum.DASHBOARD,
    new LinkSideNavButton({
      id: SideNavBarButtonsEnum.DASHBOARD,
      icon: 'insert_chart_outlined',
    }),
  ],
  [
    SideNavBarButtonsEnum.BACK_TO_PROJECT,
    new LinkSideNavButton({
      id: SideNavBarButtonsEnum.BACK_TO_PROJECT,
      icon: 'chevron_left',
      hidden: true,
    }),
  ],
  [
    SideNavBarButtonsEnum.DOCUMENTS,
    new LinkSideNavButton({
      id: SideNavBarButtonsEnum.DOCUMENTS,
      icon: 'view_list',
    }),
  ],
  [
    SideNavBarButtonsEnum.PROJECT_PARTICIPANTS,
    new LinkSideNavButton({
      id: SideNavBarButtonsEnum.PROJECT_PARTICIPANTS,
      icon: '_user-account',
      disabled: true,
    }),
  ],
  [
    SideNavBarButtonsEnum.TASKS,
    new LinkSideNavButton({
      id: SideNavBarButtonsEnum.TASKS,
      icon: '_task',
      disabled: true,
    }),
  ],
  [
    SideNavBarButtonsEnum.INBOX,
    new LinkSideNavButton({
      id: SideNavBarButtonsEnum.INBOX,
      icon: '_inbox',
      disabled: true,
    }),
  ],
  [
    SideNavBarButtonsEnum.BIM_MODELS,
    new LinkSideNavButton({
      id: SideNavBarButtonsEnum.BIM_MODELS,
      icon: '_bim-model',
      disabled: true,
    }),
  ],
  [
    SideNavBarButtonsEnum.PLANS,
    new LinkSideNavButton({
      id: SideNavBarButtonsEnum.PLANS,
      icon: '_plan_without_pin',
      disabled: true,
    }),
  ],
  [
    SideNavBarButtonsEnum.PICTURES,
    new LinkSideNavButton({
      id: SideNavBarButtonsEnum.PICTURES,
      icon: 'image',
      disabled: true,
    }),
  ],
  [
    SideNavBarButtonsEnum.PROJECT_CONFIGURATION,
    new LinkSideNavButton({
      id: SideNavBarButtonsEnum.PROJECT_CONFIGURATION,
      icon: '_project-config',
      hidden: true,
      expanded: true,
      active: false,
    }),
  ],
  [
    SideNavBarButtonsEnum.BACK_TO_PROJECT_OVERVIEW,
    new LinkSideNavButton({
      id: SideNavBarButtonsEnum.BACK_TO_PROJECT_OVERVIEW,
      icon: 'chevron_left',
      hidden: true,
    }),
  ],
  [
    SideNavBarButtonsEnum.PROJECT_DOCUMENT_TYPE_CONFIGURATION,
    new LinkSideNavButton({
      id: SideNavBarButtonsEnum.PROJECT_DOCUMENT_TYPE_CONFIGURATION,
      icon: 'description',
      parentId: SideNavBarButtonsEnum.PROJECT_CONFIGURATION,
    }),
  ],
  [
    SideNavBarButtonsEnum.GLOBAL_CONFIGURATION,
    new LinkSideNavButton({
      id: SideNavBarButtonsEnum.GLOBAL_CONFIGURATION,
      icon: '_global-config',
      disabled: false,
      alignment: SideNavButtonAlignment.bottom,
    }),
  ],
  [
    SideNavBarButtonsEnum.GLOBAL_DOCUMENT_TYPE_CONFIGURATION,
    new LinkSideNavButton({
      id: SideNavBarButtonsEnum.GLOBAL_DOCUMENT_TYPE_CONFIGURATION,
      icon: 'description',
      hidden: true,
    }),
  ],
  [
    SideNavBarButtonsEnum.MESSAGES,
    new RightDrawerButton({
      id: SideNavBarButtonsEnum.MESSAGES,
      icon: '_megaphone_outline',
      alignment: SideNavButtonAlignment.bottom,
      contentId: SideNavBarButtonsEnum.MESSAGES,
    }),
  ],
]);

export const idToTranslationKey = new Map<string, string>([
  [SideNavBarButtonsEnum.DASHBOARD, 'PR.sidebar.dashboard'],
  [SideNavBarButtonsEnum.BACK_TO_PROJECT, 'PR.sidebar.back_to_project'],
  [SideNavBarButtonsEnum.BACK_TO_PROJECT_OVERVIEW, 'PR.sidebar.back_to_project'],
  [SideNavBarButtonsEnum.PROJECT_PARTICIPANTS, 'PR.sidebar.project_participants'],
  [SideNavBarButtonsEnum.TASKS, 'PR.sidebar.tasks'],
  [SideNavBarButtonsEnum.INBOX, 'PR.sidebar.inbox'],
  [SideNavBarButtonsEnum.DOCUMENTS, 'PR.sidebar.documents'],
  [SideNavBarButtonsEnum.BIM_MODELS, 'PR.sidebar.bim_models'],
  [SideNavBarButtonsEnum.PLANS, 'PR.sidebar.plans'],
  [SideNavBarButtonsEnum.PICTURES, 'PR.sidebar.pictures'],
  [SideNavBarButtonsEnum.PROJECT_CONFIGURATION, 'PR.sidebar.project_configuration'],
  [
    SideNavBarButtonsEnum.PROJECT_DOCUMENT_TYPE_CONFIGURATION,
    'PR.sidebar.document_type_configuration',
  ],
  [SideNavBarButtonsEnum.GLOBAL_CONFIGURATION, 'PR.sidebar.global_configuration'],
  [
    SideNavBarButtonsEnum.GLOBAL_DOCUMENT_TYPE_CONFIGURATION,
    'PR.sidebar.document_type_configuration',
  ],
  [SideNavBarButtonsEnum.MESSAGES, 'PR.sidebar.messages'],
]);

export const idToUrlMap = new Map<string, string>([
  [SideNavBarButtonsEnum.DASHBOARD, PRRoutesEnum.DASHBOARD_WITH_PROJECT_ID],
  [SideNavBarButtonsEnum.DOCUMENTS, PRRoutesEnum.DOCUMENTS_WITH_PROJECT_ID],
  [SideNavBarButtonsEnum.INBOX, PRRoutesEnum.INBOX_WITH_PROJECT_ID],
  [
    SideNavBarButtonsEnum.PROJECT_DOCUMENT_TYPE_CONFIGURATION,
    PRRoutesEnum.PROJECT_DOCUMENT_TYPE_CONFIGURATION,
  ],
  [
    SideNavBarButtonsEnum.GLOBAL_DOCUMENT_TYPE_CONFIGURATION,
    PRRoutesEnum.GLOBAL_DOCUMENT_TYPE_CONFIGURATION,
  ],
  [SideNavBarButtonsEnum.GLOBAL_CONFIGURATION, PRRoutesEnum.GLOBAL_CONFIGURATION],
]);
